<template>
  <div v-if="order && formater">
    <v-sheet class="hidden-print" style="margin-top: 80px" />
    <OnePiecePrint :formater="formater" :data="order" />
  </div>
</template>
<script>
import i18n from "@/i18n";
import PrintTemplates from "@/api/print_templates";
import OnePiecePrint from "@/components/plugins/print/OnePiecePrint";
import Waves from "@/api/waves";

export default {
  components: {
    OnePiecePrint,
  },

  data: () => ({
    formater: null,
    order: {},
    waveDetails: [],
  }),

  mounted() {
    PrintTemplates.fetchOne("waveSorting").then(
      function (response) {
        if (response.data.status.isOK()) {
          var formater = response.data.print_template.template;
          this.formater = formater;
          //获取波次详情
          Waves.getPickAndSortingList(this.$route.params.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.order = response.data.data;
                this.order.start_expect_data = this.order.start_expect_data
                  ? this.$datetimeUtils.formatTime(this.order.start_expect_data)
                  : "";
                this.order.end_expect_data = this.order.start_expect_data
                  ? this.$datetimeUtils.formatTime(this.order.end_expect_data)
                  : "";
                var pickAndSorting = response.data.data.wave.pick_and_sorting;
                var idx = 0;
                pickAndSorting.forEach((item) => {
                  ++idx;
                  item.idx = idx;
                  item.positionDescription = i18n.t(
                    "Position.positionNameWithCode",
                    [item.position_code, item.position_name]
                  );
                  item.detail.materialDescription = i18n.t(
                    this.settings
                      ? this.settings.material_name_display_type == 4
                        ? "Material.nameWithCodeAndStandard"
                        : this.settings.material_name_display_type == 3
                        ? "Material.materialNameWithCodeAndStandard"
                        : this.settings.material_name_display_type == 2
                        ? "Material.materialNameWithCode"
                        : "Material.materialName"
                      : "Material.materialName",
                    [
                      item.detail.material_code,
                      item.detail.material_name,
                      item.detail.standard_name,
                    ]
                  );
                  //格式化指引
                  item.detail.pick_info.forEach((info) => {
                    item.detail.guide = i18n.t("Wave.StockSortingPrint.guide_value", [
                      info.show_num,
                      this.$numberFormatter.formatWithDotNoMoreThan(
                        info.positon_num,
                        2
                      ),
                    ]);
                  });
                  // console.log(item);
                });
              }
              // console.log(pickAndSorting);
              // this.waveDetails = pickAndSorting;
              this.order.wave.pick_and_sorting = pickAndSorting;
              // console.log(this.order)
            }.bind(this)
          );
        }
      }.bind(this)
    );
  },
};
</script>